
<svelte:head>
  <title>{data?.name || "Offer"} | A Good Thing</title>
</svelte:head>

{#if !data}

  {#if notFound}
  <article class="message is-success">
    <div class="message-body">
      <p class="block">
        <b>This item is no longer available.</b>
      </p>
      <p class="block">
        View current live offers <a href="{$appState.origin}/signup">here</a> .
      </p>
    </div>
  </article>
  {/if}

{:else}


{#if archived}
<article class="message is-success">
  <div class="message-body">
    <p class="block">
      <b>This item is no longer available, but are you a local charity that could use items like this?</b>
    </p>
    <p class="block">
      <a href="{$appState.origin}/signup">Sign up</a> to view and request offers like this. It's free and easy.
    </p>
  </div>
</article>

{:else}

<article class="message is-success">
  <div class="message-body">
    <p class="block">
      <b>Are you a charity that could use this item?</b>
    </p>
    <p class="block">
      A Good Thing is a digital platform that makes it easy for businesses to donate unwanted items to local charities. The items are free and collected directly from the business (or sometimes posted by the business). <a href="{$appState.origin}/signup">Sign up</a> to get started. It's free and easy.
    </p>
    <p class="block">
      Already signed up? <a href="{$appState.origin}/charity/offer/{id}">Log in</a> to request this
      offer.
    </p>
  </div>
</article>

{/if}

<div class="columns">
    <div class="column is-narrow">
      {#if data.images?.[0]}
        <img
          alt="Offer"
          on:click={() => {
            $uiState.activeModal = {
              component: Lightbox,
              props: { images: data.images, index: 0 },
            };
          }}
          src={data.images[0]}
          style="width:240px; cursor:pointer;"
        />
      {:else}
        <img
          alt="Generic"
          src="/assets/img/box.png"
          style="height:240px;width:240px; background-color:lightgrey"
        />
      {/if}
      <div style="width:250px;">
        {#if data.images?.length > 1}
          {#each data.images as url, index}
            {#if index !== 0}
              <div style="display:inline-block;margin-right: 8px;">
                <img
                  alt="Offer"
                  on:click={() => {
                    $uiState.activeModal = {
                      component: Lightbox,
                      props: { images: data.images, index },
                    };
                  }}
                  src={url}
                  style="max-width:116px;"
                />
              </div>
            {/if}
          {/each}
        {/if}
      </div>
    </div>

    <div class="column">

      <nav class="level">
        <div class="level-left level-can-wrap">
          <div class="level-item level-can-wrap">
            <h2 class="title">{data.name}</h2>
          </div>
        </div>
      </nav>

      {#if createdDatePhrase}
        <p class="block has-text-grey-light">Published {createdDatePhrase}</p>
      {/if}

      {#if data.options?.nationwide || data.options?.divisible}
      <div class="block">
        {#if data.options?.nationwide}
        <span class="tag is-info is-medium">Offered nationwide via post</span>
        {/if}
        {#if data.options?.divisible}
        <span class="tag is-warning is-medium">Can be split</span>
        {/if}
      </div>
      {/if}

      <p class="block" style="white-space:pre-wrap;">{data.description}</p>

      <hr />

      <div class="block is-size-4">Offered by a local business</div>

      {#if data.location}
        <div class="block">
          <Map location={data.location} drawCircle />
        </div>
      {/if}
    </div>
  </div>
{/if}

<script lang="ts">
  export let id : string;

  import _ from "lodash";
  import { appState } from "../../../lib/appState";
  import { uiState } from "../../../lib/uiState";
  import Map from "../../_components/MapJS.svelte";
  import dayjs from "dayjs";
  import relativeTime from "dayjs/plugin/relativeTime";
  import Lightbox from "../../_components/Lightbox.svelte";

  dayjs.extend(relativeTime);

  let archived = false;
  let notFound = false;

  let data : PublishedOffer_v1;

  let firebase = window.firebase;

  $: createdDatePhrase = data?.created ? dayjs().to(dayjs(data.created)) : undefined;

  get();

  async function get() {

    const doc = await firebase
      .firestore()
      .collection("published_offers_v1")
      .doc(id)
      .get();

    if(doc.exists) {
      data = doc.data() as PublishedOffer_v1;
    }
    else {
      const archivedDoc = await firebase
      .firestore()
      .collection("published_offers_archive_v1")
      .doc(id)
      .get();

      if(archivedDoc.exists) {
        archived = true;
        data = archivedDoc.data() as PublishedOffer_v1;
      }
      else {
        notFound = true;
      }
    }
  }
</script>
